import { useEffect } from "react";
import { useDispatch } from "react-redux";
import {fetchGallery, selectGalleryItems, selectGalleryLoading, selectGalleryFetched, useAppSelector} from "../../store";
import { GalleryView } from "./parts";

export const Gallery = () => {
  const dispatch = useDispatch();

  const items = useAppSelector(selectGalleryItems);
  const loading = useAppSelector(selectGalleryLoading);
  const fetched = useAppSelector(selectGalleryFetched);

  useEffect(() => {
    if (items?.length === 0 && !loading && !fetched)
      dispatch(fetchGallery());
  }, [dispatch, items, loading, fetched]);

  return (
    <div className="body">
      <GalleryView />
    </div>
  )
}